import React from 'react';

const AboutPage = () => {
  return (
    <div>
      <h1>About Us</h1>
    </div>
  );
};

export default AboutPage;
